import { useApolloClient, useMutation, useQuery } from '@apollo/client';
import { useSearchParams } from 'react-router-dom';

import { GET_EDIT_BOOK } from './queries';
import { UPDATE_BOOK, UPDATE_BOOK_WITH_PRODUCT } from './mutations';
import CollaborationPage from '../../containers/CollaborationPage';
import Text from '../../components/Text';
import { FormattedMessage } from 'react-intl';
import Form from './Form';
import ProductPreviewCard from '../../components/ProductPreviewCard';
import { useState } from 'react';

const EditBook = () => {
  const client = useApolloClient();
  const [sp] = useSearchParams();
  const i = sp.get('i');
  const id = i ? parseInt(i, 10) : null;

  const [completed, setCompleted] = useState(false);

  const [showContactError, setContactError] = useState(false);

  const { data, loading, error, refetch } = useQuery(GET_EDIT_BOOK, {
    variables: {
      id,
    },
  });

  const onCompleted = () => {
    setCompleted(true);
    client.cache.evict({ fieldName: 'listBooks' });
    client.cache.evict({ id: `Book:${id}` });
  };

  const options = {
    onCompleted,
    onError: () => {
      setCompleted(false);
    },
  };

  const mutation = data?.getBook?.product
    ? UPDATE_BOOK_WITH_PRODUCT
    : UPDATE_BOOK;

  const [update, { loading: isUpdating }] = useMutation(mutation, options);

  const handleUpdate = (input) => {
    if (!input?.contactEmail && !input?.contactPhone) {
      setContactError(true);
      return;
    }

    update({
      variables: {
        id,
        input: {
          ...input,
          price: parseInt(input.price, 10),
          conditionId: parseInt(input.conditionId, 10),
        },
      },
    });
  };

  return (
    <CollaborationPage
      className="pt-1 pb-5"
      loading={loading}
      error={error}
      onRetry={refetch}
    >
      <Text variant="header">
        <FormattedMessage defaultMessage="Ändra inlägg" />
      </Text>

      {data?.getBook?.product && (
        <ProductPreviewCard
          product={data?.getBook?.product}
          className="mb-3"
          showButtons={false}
          withLargeTitle={false}
        />
      )}

      <Form
        book={data?.getBook}
        isUpdating={isUpdating}
        onUpdate={handleUpdate}
        showContactError={showContactError}
        completed={completed}
      />
    </CollaborationPage>
  );
};

export default EditBook;
